export default __webpack_public_path__ + "static/media/bg6.180d01d5.jpg";